<template>
  <div class="container">
    <vue-headful title="ABL Groupe | Realisations" />
    <h2>Passerelle Coeur d'Orly Paris</h2>
    <section class="society--process">
      <div class="society--content">
        <div class="society--process--picture col-xs-12 col-md-5 ">
            <img :src="require('../../assets/images/orly-sud-photo.jpg')"/>
            <img height="400" width="400" :src="require('../../assets/images/orly-schema.jpg')"/>
        </div>
        <div class="society--process--description flex-end col-xs-12 col-md-5">
          <div class="col-xs-12 schema--container">
            <h3>Profils extrudés d'insert d'éclairage</h3>
            <div>
              <p>Dimensions : 121 x 52 mm et 106 x 32 mm</p>
              <p>Matière : S 355</p>
              <p>Architecte : ADP</p>
            </div>
            <img height="300" width="300" class="img--schema" :src="require('../../assets/images/schema-coeur-orly.jpg')"/>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ExtrudedLightingInsertProfiles"
}
</script>

<style lang="scss">
.schema--container {
  display: flex;
  flex-direction: column;
  & .img--schema {
    margin-top: auto;
  }
}
.society--process {
  & img {
    object-fit: cover;
    width: 100%;
  }
  & .img--schema {
    object-fit: contain;
  }
}
</style>